import { BRAND } from "../config";

import aba from "./a-basin";
import base from "./base";
import bbm from "./big-bear";
import blm from "./blue-mountain";
import crm from "./crystal";
import dvr from "./deervalley";
import fnb from "./food-and-beverage";
import ikon from "./ikon";
import ikonapp from "./ikon-app";
import { ThemesInterface } from "./interface";
import jun from "./june";
import mam from "./mammoth";
import sqa from "./palisades-tahoe";
import szm from "./schweitzer";
import sno from "./snowshoe";
import sol from "./solitude";
import sb from "./steamboat";
import str from "./stratton";
import sug from "./sugarbush";
import trb from "./tremblant";
import wp from "./winterpark";

export const themes = {
  base,
  sol,
  mam,
  wp,
  sb,
  dvr,
  crm,
  sqa,
  str,
  bbm,
  sug,
  blm,
  sno,
  trb,
  jun,
  "f&b": fnb,
  ikon,
  ikonapp,
  szm,
  aba,
} as ThemesInterface;

export const getTheme = (brand: string) => themes[brand] || base;
export const theme = getTheme(BRAND);
